(() => {

  const SLIDER_SELECTOR = '[data-product-card-slider]';


  function initProductCardSlider(slider) {

    if (!slider) return;

    if (slider.dataset.sliderInitialized === 'true') {
      return;
    }


    const track = slider.querySelector(
      '[data-product-card-slider-track]'
    );

    const slides = Array.from(
      slider.querySelectorAll(
        '[data-product-card-slide]'
      )
    );

    const prevButton = slider.querySelector(
      '[data-product-card-prev]'
    );

    const nextButton = slider.querySelector(
      '[data-product-card-next]'
    );

    const dots = Array.from(
      slider.querySelectorAll(
        '[data-product-card-dot]'
      )
    );


    if (!track || slides.length <= 1) {
      return;
    }


    slider.dataset.sliderInitialized = 'true';


    let currentIndex = 0;
    let scrollTimeout;


    /* =====================================================
       WIDTH
    ===================================================== */

    function getSlideWidth() {

      return track.clientWidth;

    }


    /* =====================================================
       DOTS
    ===================================================== */

    function updateDots() {

      dots.forEach((dot, index) => {

        dot.classList.toggle(
          'is-active',
          index === currentIndex
        );

      });

    }


    /* =====================================================
       GO TO SLIDE
    ===================================================== */

    function goToSlide(index) {

      const maxIndex = slides.length - 1;


      /*
       * LOOP
       */

      if (index < 0) {

        index = maxIndex;

      }


      if (index > maxIndex) {

        index = 0;

      }


      currentIndex = index;


      track.scrollTo({

        left: getSlideWidth() * currentIndex,

        behavior: 'smooth'

      });


      updateDots();

    }


    /* =====================================================
       PREVIOUS
    ===================================================== */

    if (prevButton) {

      prevButton.addEventListener(
        'click',
        function(event) {

          event.preventDefault();
          event.stopPropagation();

          goToSlide(currentIndex - 1);

        }
      );

    }


    /* =====================================================
       NEXT
    ===================================================== */

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function(event) {

          event.preventDefault();
          event.stopPropagation();

          goToSlide(currentIndex + 1);

        }
      );

    }


    /* =====================================================
       UPDATE AFTER SWIPE
    ===================================================== */

    track.addEventListener(
      'scroll',
      function() {

        clearTimeout(scrollTimeout);


        scrollTimeout = setTimeout(
          function() {

            const slideWidth = getSlideWidth();


            if (!slideWidth) {
              return;
            }


            currentIndex = Math.round(
              track.scrollLeft / slideWidth
            );


            currentIndex = Math.max(
              0,
              Math.min(
                currentIndex,
                slides.length - 1
              )
            );


            updateDots();

          },
          50
        );

      },
      {
        passive: true
      }
    );


    /* =====================================================
       INITIAL STATE
    ===================================================== */

    updateDots();

  }


  /* =======================================================
     INITIALIZE ALL
  ======================================================= */

  function initAllProductCardSliders(context = document) {

    context
      .querySelectorAll(SLIDER_SELECTOR)
      .forEach(initProductCardSlider);

  }


  /* =======================================================
     INITIAL PAGE
  ======================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function() {

        initAllProductCardSliders();

      }
    );

  } else {

    initAllProductCardSliders();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function(event) {

      initAllProductCardSliders(event.target);

    }
  );


  /* =======================================================
     COLLECTION FILTERS / AJAX
     
     Prestige pode reconstruir o grid de produtos.
     MutationObserver inicializa somente novos sliders.
  ======================================================= */

  const observer = new MutationObserver(
    function(mutations) {

      mutations.forEach(function(mutation) {

        mutation.addedNodes.forEach(function(node) {

          if (!(node instanceof HTMLElement)) {
            return;
          }


          if (node.matches?.(SLIDER_SELECTOR)) {

            initProductCardSlider(node);

          }


          node
            .querySelectorAll?.(SLIDER_SELECTOR)
            .forEach(initProductCardSlider);

        });

      });

    }
  );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();